import { render, staticRenderFns } from "./elite_resume.vue?vue&type=template&id=070c9628&scoped=true&"
import script from "./elite_resume.vue?vue&type=script&lang=js&"
export * from "./elite_resume.vue?vue&type=script&lang=js&"
import style0 from "./elite_resume.vue?vue&type=style&index=0&id=070c9628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c9628",
  null
  
)

export default component.exports